import GateService from 'Services/GateService.js'
import PropertyService from 'Services/PropertyService.js'
import ServerService from 'Services/ServerService.js'
import ContactService from 'Services/ContactService.js'
import BlePassService from 'Services/BlePassService.js'

export default {
  data() {
    return {
      gateService: GateService,
      propertyService: PropertyService,
      serverService: ServerService,
      contactService: ContactService,
      blePassService: BlePassService,
    }
  },
  methods: {
    async getGates(filters = {}) {
      await this.gateService
        .getGates(filters)
        .then(response => {
          if (response.meta) {
            this.$store.dispatch('setGatesMeta', response.meta)
          }

          if (response.data) {
            this.$store.dispatch('setGates', response.data)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    async getProperties(filters = {}) {
      await this.propertyService
        .getProperties(filters)
        .then(response => {
          if (response.data) {
            this.$store.dispatch('setProperties', response.data)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getPropertiesWithContacts(string = null) {
      this.propertyService
        .getPropertiesWithContacts(string)
        .then(response => {
          if (response.data) {
            this.$store.dispatch('setPropertiesWithContacts', response.data)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    async getServers(filters = {}) {
      await this.serverService
        .getServers(filters)
        .then(response => {
          if (response.meta) {
            this.$store.dispatch('setServersMeta', response.meta)
          }

          if (response.data) {
            this.$store.dispatch('setServers', response.data)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    async getServerHealthCheck(suid) {
      if (!suid) return
      if (!this.$_healthCheckInFlight) {
        this.$_healthCheckInFlight = new Set()
      }
      if (this.$_healthCheckInFlight.has(suid)) return
      this.$_healthCheckInFlight.add(suid)
      try {
        const response = await this.serverService.getHealthCheck(suid)
        if (response.data) {
          this.$store.dispatch('setServerHealthCheck', {
            suid,
            data: response.data,
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.$_healthCheckInFlight.delete(suid)
      }
    },
    getContactsByOrganization(
      organizationId,
      propertyId = null,
      sipServerId = null
    ) {
      this.contactService
        .getContactsByOrganization(organizationId, propertyId, sipServerId)
        .then(response => {
          this.$store.dispatch('setContacts', response.data ?? [])
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.$store.dispatch('setNotification', {
              text: error.response.data.message ?? 'Error',
            })
          }
        })
    },
    getContacts(filters = {}) {
      return new Promise((resolve, reject) => {
        this.contactService
          .getContacts(filters)
          .then(response => {
            this.$store.dispatch(
              'setContactsMeta',
              response.data ? response.data : {}
            )
            this.$store.dispatch(
              'setContacts',
              response.data && response.data.data ? response.data.data : []
            )

            resolve(response)
          })
          .catch(error => {
            if (error.response && error.response.data) {
              this.$store.dispatch('setNotification', {
                text: error.response.data.message ?? 'Error',
              })
            }

            resolve(error)
          })
      })
    },
    getVerifiedColumnContent(id, label) {
      let content = { id: id }

      if (label) {
        content['label-true'] = label
      } else {
        content['label-false'] = label
      }

      return content
    },
    getAccessRules(serverId) {
      return new Promise((resolve, reject) => {
        this.serverService
          .getAccessRules(serverId)
          .then(response => {
            this.$store.dispatch('setServerRules', {
              serverId: serverId,
              rules: response.data,
            })

            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getBlePasses(cuid, filters = {}) {
      return new Promise((resolve, reject) => {
        this.blePassService
          .getBlePasses(cuid, filters)
          .then(response => {
            if (response.data) {
              this.$store.dispatch('setBlePasses', response.data)
            }
            if (response.meta) {
              if (response.meta.issuers) {
                this.$store.dispatch('setBleIssuers', response.meta.issuers)
              }
              if (response.meta.current_page !== undefined) {
                this.$store.dispatch('setBlePassesMeta', {
                  current_page: response.meta.current_page,
                  per_page: response.meta.per_page,
                  total: response.meta.total,
                })
              }
            }
            resolve(response)
          })
          .catch(error => {
            this.$store.dispatch('setNotification', {
              text:
                error.response?.data?.message ||
                'Ошибка при загрузке BLE пропусков.',
              type: 'cross-outlined',
            })
            reject(error)
          })
      })
    },
  },
  computed: {
    gateList() {
      return this.$store.getters.gates
    },
    gatesMeta() {
      return this.$store.getters.gatesMeta
    },
    serverList() {
      return this.$store.getters.servers
    },
    serversMeta() {
      return this.$store.getters.serversMeta
    },
    propertyList() {
      return this.$store.getters.properties
    },
    contactList() {
      return this.$store.getters.contacts
    },
    contactsMeta() {
      return this.$store.getters.contactsMeta
    },
    propertiesWithContactsList() {
      return this.$store.getters.propertiesWithContacts
    },
    serverListOptions() {
      let serverListOptions = []

      this.serverList.forEach(server => {
        serverListOptions.push({
          id: server.suid,
          label: server.host,
        })
      })

      return serverListOptions
    },
    propertyListOptions() {
      let propertyListOptions = []

      this.propertyList.forEach(property => {
        propertyListOptions.push({
          id: property.puid,
          label: property.address,
        })
      })

      return propertyListOptions
    },
    gatePropertyListOptions() {
      let gatePropertyList = []
      let seenAddresses = new Set()

      this.gateList.forEach(gate => {
        const address = gate.property.address

        if (!seenAddresses.has(address)) {
          seenAddresses.add(address)
          gatePropertyList.push({
            id: gate.property.puid,
            label: address,
          })
        }
      })

      return gatePropertyList
    },
    currentOrganizationId() {
      return this.$store.getters.currentOrganizationId
    },
    serverRules() {
      return this.$store.getters.serverRules
    },
    serverHealthChecks() {
      return this.$store.getters.serverHealthChecks
    },
  },
}
